<fgb-page-header [pageTitle]="'rewards.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'featured.rewards.page.title' | translate"></fgb-banner>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-3">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[0, 1, 2]"
    [defaultSort]="2"
    [showSortBar]="false"
  ></fgbcl-marketplace-list>
</div>
